import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ModalCreateClientService {

    constructor() { }

    public _visible: boolean = false;

    public newClientCreated: EventEmitter<string> = new EventEmitter<string>();

    get ocultarModal() {
        return this._visible;
    }

    visibleModal(): boolean {
        return !this._visible
    }

    showModal() {
        this._visible = true;
    }

    closeModal() {
        this._visible = false;
    }

}
